import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { setAppError } from "../../actions/App/dispatchers";
import { HTTP_NOT_FOUND, validErrorCodeOr404 } from "../../constants/http";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";

export const notFound = (url) => async (dispatch) => {
    dispatch(reset_app_state(url));
    dispatch(reset_right_rail());
    dispatch(setAppError(url, HTTP_NOT_FOUND));
};

export const errorCode = (url) => async (dispatch) => {
    let statusNumber = 404; // Default to 404 status code

    if (url.includes("/error/")) {
        // url will be in the form of /error/:status
        // split will provide ["", "404"]
        statusNumber = Number(url.split("/error/")[1]);
    } else {
        // url will be in the form of /{code}.html
        statusNumber = Number(url.match(/\/(\d+)\.html/)[1]);
    }
    const statusCode = validErrorCodeOr404(statusNumber);

    dispatch(reset_app_state(url));
    dispatch(reset_right_rail());
    dispatch(setAppError(url, statusCode));
};
